<script lang="ts">
</script>

<div class="dangerous-action | p-4 border-red-700 bg-red-100" role="alert">
  <slot />
</div>

<style>
  .dangerous-action {
    border-left-width: 4px;
  }
</style>
